export default {

  getTranslated: (state) => (locale, key) => {
    let selections = state.selections;

    var selectionItemToBeGet = 'selectionValueEnglish';
    var translatedOptionsList = [];
    switch (locale.toLowerCase()) {
      case 'en_us':
        selectionItemToBeGet = 'selectionValueEnglish';
        break;
      case 'zh_hk':
        selectionItemToBeGet = 'selectionValueZhHk';
        break;
      case 'zh_cn':
        selectionItemToBeGet = 'selectionValueZhCn';
        break;
    }

    if (!selections) {
      return [];
    }

    let result = selections.filter((item) => {
      return key === item.name;
    }).map((item) => {
      return {
        name: item.name,
        options: item.options.map((item) => {
          return {
            value: item.selectionKey,
            text: item[selectionItemToBeGet]
          }
        })
      }
    });

    return result.length > 0 ? result[0].options : [];
  },
}



// WEBPACK FOOTER //
// ./src/Dw/store/getters.js